import PropTypes from 'prop-types'
import React from 'react'
import { FormattedMessage, FormattedDate } from 'react-intl'
import { FormattedDistance, FormattedDuration, FormattedEnergy } from 'shared/units'
import styles from './_workout.css'

export function Workout ({ workout }) {
  const id = workout._links.self[0].id
  const routeThumb = workout.route && workout.route._links.thumbnail[0].href
  const activityIcon = workout.activity._links.icon_url[0].href
  const { aggregates } = workout

  return (
    <div className={styles.container}>
      {routeThumb ?
        <div className={styles.route}>
          <img className={styles.thumbnail} src={routeThumb} />
        </div>
      : null}
      <div className={styles.summary}>
        <a className={styles.name} href={`/workout/${id}`}>
          {workout.name}
        </a>
        <div className={styles.distanceContainer}>
          <div>
            <FormattedMessage id='home.workout.dist' defaultMessage='Distance' />
          </div>
          <div className={styles.distance}>
            <FormattedDistance value={aggregates.distance_total} />
          </div>
        </div>
      </div>
      <div className={styles.details}>
        <div>
          <div className={styles.detailLabel}>
            <FormattedMessage id='home.workout.duration' defaultMessage='Duration' />
          </div>
          <div className={styles.detailVal}>
            <FormattedDuration digits={1} value={aggregates.active_time_total} />
          </div>
        </div>
        {aggregates.metabolic_energy_total ?
          <div className={styles.calorieDetails}>
            <div className={styles.detailLabel}>
              <FormattedMessage id='home.workout.cals' defaultMessage='Calories Burned' />
            </div>
            <div className={styles.detailVal}>
              <FormattedEnergy digits={0} value={aggregates.metabolic_energy_total} />
            </div>
          </div>
        : null}
      </div>
      <div className={styles.dateActivity}>
        <div className={styles.date}>
          <FormattedDate value={workout.created_datetime} />
        </div>
        <div className={styles.iconContainer}>
          <img title={workout.activity.name} className={styles.activityIcon} src={activityIcon} />
        </div>
      </div>
    </div>
  )
}

Workout.propTypes = {
  workout: PropTypes.object,
}

export default Workout



// WEBPACK FOOTER //
// ./src/components/home/workouts/Workout.jsx